export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["Smile"] = "Smile";
    FeedbackType["Frown"] = "Frown";
    FeedbackType["Idea"] = "Idea";
    FeedbackType["Unclassified"] = "Unclassified";
    FeedbackType["Survey"] = "Survey";
})(FeedbackType || (FeedbackType = {}));
export var FeedbackAgeGroup;
(function (FeedbackAgeGroup) {
    FeedbackAgeGroup["Undefined"] = "Undefined";
    FeedbackAgeGroup["MinorWithoutParentalConsent"] = "MinorWithoutParentalConsent";
    FeedbackAgeGroup["MinorWithParentalConsent"] = "MinorWithParentalConsent";
    FeedbackAgeGroup["NotAdult"] = "NotAdult";
    FeedbackAgeGroup["Adult"] = "Adult";
    FeedbackAgeGroup["MinorNoParentalConsentRequired"] = "MinorNoParentalConsentRequired";
})(FeedbackAgeGroup || (FeedbackAgeGroup = {}));
export var FeedbackAuthenticationType;
(function (FeedbackAuthenticationType) {
    FeedbackAuthenticationType["MSA"] = "MSA";
    FeedbackAuthenticationType["AAD"] = "AAD";
    FeedbackAuthenticationType["Unauthenticated"] = "Unauthenticated";
})(FeedbackAuthenticationType || (FeedbackAuthenticationType = {}));
export var FeedbackPolicyValue;
(function (FeedbackPolicyValue) {
    FeedbackPolicyValue["Enabled"] = "Enabled";
    FeedbackPolicyValue["Disabled"] = "Disabled";
    FeedbackPolicyValue["NotConfigured"] = "Not Configured";
    /**
     * For feedback applications outside of M365, OCPS policies do not currently apply. This value
     * is an explicit indication of that condition. In other words, this value should not be used unless
     * the integrating partner is not part of M365 and knows that OCPS policies do not apply.
     */
    FeedbackPolicyValue["NotApplicable"] = "Not Applicable";
})(FeedbackPolicyValue || (FeedbackPolicyValue = {}));
export var FeedbackScreenshotInfoImageFormat;
(function (FeedbackScreenshotInfoImageFormat) {
    FeedbackScreenshotInfoImageFormat["JPEG"] = "jpeg";
    FeedbackScreenshotInfoImageFormat["PNG"] = "png";
})(FeedbackScreenshotInfoImageFormat || (FeedbackScreenshotInfoImageFormat = {}));
export var FeedbackScreenshotInfoImageOrientation;
(function (FeedbackScreenshotInfoImageOrientation) {
    FeedbackScreenshotInfoImageOrientation["Landscape"] = "Landscape";
    FeedbackScreenshotInfoImageOrientation["Potrait"] = "Potrait";
})(FeedbackScreenshotInfoImageOrientation || (FeedbackScreenshotInfoImageOrientation = {}));
// All enums should be string
export var FeedbackScreenshotSourceType;
(function (FeedbackScreenshotSourceType) {
    FeedbackScreenshotSourceType["AutoCapture"] = "AutoCapture";
    FeedbackScreenshotSourceType["AutoCaptureWithHtml2Canvas"] = "AutoCaptureWithHtml2Canvas";
    FeedbackScreenshotSourceType["ProvidedAtInitialization"] = "ProvidedAtInitialization";
    FeedbackScreenshotSourceType["DynamicallyProvided"] = "DynamicallyProvided";
})(FeedbackScreenshotSourceType || (FeedbackScreenshotSourceType = {}));
export var FeedbackUiType;
(function (FeedbackUiType) {
    FeedbackUiType["SidePane"] = "SidePane";
    FeedbackUiType["Modal"] = "Modal";
    FeedbackUiType["CallOut"] = "CallOut";
    FeedbackUiType["IFrameWithinSidePane"] = "IFrameWithinSidePane";
    FeedbackUiType["IFrameWithinModal"] = "IFrameWithinModal";
    FeedbackUiType["IFrameWithinCallOut"] = "IFrameWithinCallOut";
    FeedbackUiType["NoSurface"] = "NoSurface";
    FeedbackUiType["NoSurfaceWithoutTitle"] = "NoSurfaceWithoutTitle";
})(FeedbackUiType || (FeedbackUiType = {}));
export var FeedbackHostPlatformType;
(function (FeedbackHostPlatformType) {
    FeedbackHostPlatformType["Windows"] = "Windows";
    FeedbackHostPlatformType["IOS"] = "iOS";
    FeedbackHostPlatformType["Android"] = "Android";
    FeedbackHostPlatformType["WacTaskPane"] = "WacTaskPane";
    FeedbackHostPlatformType["MacOS"] = "MacOS";
    FeedbackHostPlatformType["Web"] = "Web";
    FeedbackHostPlatformType["IFrame"] = "IFrame";
})(FeedbackHostPlatformType || (FeedbackHostPlatformType = {}));
export var FeedbackHostEventName;
(function (FeedbackHostEventName) {
    FeedbackHostEventName["SubmitClicked"] = "InAppFeedback_HostEvent_SubmitClicked";
    FeedbackHostEventName["BackClicked"] = "InAppFeedback_HostEvent_BackClicked";
})(FeedbackHostEventName || (FeedbackHostEventName = {}));
export var InitializationStatus;
(function (InitializationStatus) {
    InitializationStatus["Success"] = "Success";
    InitializationStatus["Error"] = "Error";
    InitializationStatus["Warning"] = "Warning";
})(InitializationStatus || (InitializationStatus = {}));
export var InAppFeedbackQuestionUiType;
(function (InAppFeedbackQuestionUiType) {
    InAppFeedbackQuestionUiType["DropDown"] = "DropDown";
    InAppFeedbackQuestionUiType["MultiSelect"] = "MultiSelect";
    InAppFeedbackQuestionUiType["Rating"] = "Rating";
    InAppFeedbackQuestionUiType["SingleSelect"] = "SingleSelect";
    InAppFeedbackQuestionUiType["SingleSelectHorizontal"] = "SingleSelectHorizontal";
})(InAppFeedbackQuestionUiType || (InAppFeedbackQuestionUiType = {}));
export var InAppFeedbackScenarioType;
(function (InAppFeedbackScenarioType) {
    InAppFeedbackScenarioType["FeatureArea"] = "FeatureArea";
    InAppFeedbackScenarioType["ResponsibleAI"] = "ResponsibleAI";
    InAppFeedbackScenarioType["Experience"] = "Experience";
    InAppFeedbackScenarioType["ProductSatisfaction"] = "ProductSatisfaction";
    InAppFeedbackScenarioType["CrashImpact"] = "CrashImpact";
    InAppFeedbackScenarioType["Custom"] = "Custom";
    InAppFeedbackScenarioType["AIThumbsDown"] = "AIThumbsDown";
    InAppFeedbackScenarioType["AIThumbsUp"] = "AIThumbsUp";
    InAppFeedbackScenarioType["AIError"] = "AIError";
    InAppFeedbackScenarioType["AIGeneral"] = "AIGeneral";
    InAppFeedbackScenarioType["PromptSuggestion"] = "PromptSuggestion";
})(InAppFeedbackScenarioType || (InAppFeedbackScenarioType = {}));
export var InAppFeedbackQuestionUiBehaviour;
(function (InAppFeedbackQuestionUiBehaviour) {
    InAppFeedbackQuestionUiBehaviour["QuestionNotRequired"] = "QuestionNotRequired";
    InAppFeedbackQuestionUiBehaviour["CommentNotRequired"] = "CommentNotRequired";
    InAppFeedbackQuestionUiBehaviour["CommentRequiredWithLastOption"] = "CommentRequiredWithLastOption";
})(InAppFeedbackQuestionUiBehaviour || (InAppFeedbackQuestionUiBehaviour = {}));
export var FeedbackAttachmentOrigin;
(function (FeedbackAttachmentOrigin) {
    FeedbackAttachmentOrigin["Application"] = "Application";
    FeedbackAttachmentOrigin["User"] = "User";
})(FeedbackAttachmentOrigin || (FeedbackAttachmentOrigin = {}));
export var FeedbackEntryPoint;
(function (FeedbackEntryPoint) {
    FeedbackEntryPoint["Header"] = "Header";
    FeedbackEntryPoint["Footer"] = "Footer";
    FeedbackEntryPoint["Backstage"] = "Backstage";
    FeedbackEntryPoint["HelpMenu"] = "Help Menu";
    FeedbackEntryPoint["Canvas"] = "Canvas";
    FeedbackEntryPoint["Chat"] = "Chat";
})(FeedbackEntryPoint || (FeedbackEntryPoint = {}));
export var FeedbackIntegrationSource;
(function (FeedbackIntegrationSource) {
    FeedbackIntegrationSource["MSO"] = "MSO";
    FeedbackIntegrationSource["SDX"] = "SDX";
    FeedbackIntegrationSource["VivaUX"] = "VivaUX";
    FeedbackIntegrationSource["OneShell"] = "OneShell";
    FeedbackIntegrationSource["Teams"] = "Teams";
    FeedbackIntegrationSource["Outlook"] = "Outlook";
})(FeedbackIntegrationSource || (FeedbackIntegrationSource = {}));
/**
 * The identity of the cloud the current tenant is hosted on.
 *
 * Certain clouds have specific restrictions around feedback collection. For example, `UsGovDod` tenants are not allowed
 * to provide feedback at all. In that specific case, we would expect the host app to disable the feedback button, but
 * we have a fallback check in the SDK as well.
 *
 * These values are from the M365 perspective. E.g. Azure would understand them slightly differently.
 *
 * See https://www.owiki.ms/wiki/ICE_Services/Config#Data_Boundary_Sovereignties for more information.
 */
export var TenantCloudType;
(function (TenantCloudType) {
    /**
     * The default cloud type that most tenants are hosted on. I.e. "Commercial" cloud
     */
    TenantCloudType["Worldwide"] = "Worldwide";
    TenantCloudType["China"] = "China";
    /**
     * European Union Data Boundary
     */
    TenantCloudType["EUDB"] = "EUDB";
    /**
     * Government Community Cloud (GCC)
     */
    TenantCloudType["GccMod"] = "GccMod";
    /**
     * Also known as GCC High
     *
     * Part of US Sovereign Cloud
     */
    TenantCloudType["UsGov"] = "UsGov";
    /**
     * US Government Department of Defense
     *
     * Part of US Sovereign Cloud
     */
    TenantCloudType["UsGovDod"] = "UsGovDod";
    /**
     * Treated the same as DoD by the Feedback SDK
     */
    TenantCloudType["UsNat"] = "UsNat";
    /**
     * Treated the same as DoD by the Feedback SDK
     */
    TenantCloudType["UsSec"] = "UsSec";
})(TenantCloudType || (TenantCloudType = {}));
export var UserAccessTokenAudience;
(function (UserAccessTokenAudience) {
    UserAccessTokenAudience["ODS"] = "ODS";
    UserAccessTokenAudience["TenantFeedback"] = "TenantFeedback";
})(UserAccessTokenAudience || (UserAccessTokenAudience = {}));
export var FeedbackScreenshotAutoCaptureConfigSetting;
(function (FeedbackScreenshotAutoCaptureConfigSetting) {
    FeedbackScreenshotAutoCaptureConfigSetting["Include"] = "include";
    FeedbackScreenshotAutoCaptureConfigSetting["Exclude"] = "exclude";
})(FeedbackScreenshotAutoCaptureConfigSetting || (FeedbackScreenshotAutoCaptureConfigSetting = {}));
export var TenantFeedbackScenarioType;
(function (TenantFeedbackScenarioType) {
    /**
     * Feedback for conversation-based Copilot, for example BizChat or CWC
     */
    TenantFeedbackScenarioType["CopilotChatFeedback"] = "CopilotChatFeedback";
    /**
     * General feedback without any specified Copilot output
     */
    TenantFeedbackScenarioType["CopilotGlobalFeedback"] = "CopilotGlobalFeedback";
    /**
     * General feedback for catch-up/feeding content
     */
    TenantFeedbackScenarioType["CopilotCatchUpFeedback"] = "CopilotCatchUpFeedback";
    /**
     * Feedback for assistant (non-conversational) features, such as email summary, meeting recap, doc rewrite, etc
     */
    TenantFeedbackScenarioType["CopilotAssistantFeedback"] = "CopilotAssistantFeedback";
})(TenantFeedbackScenarioType || (TenantFeedbackScenarioType = {}));
export var ComplianceMapping = {
    connectedExperiences: 'L_ConnectedOfficeExperiences',
    policyAllowFeedback: 'L_SendFeedback',
    policyAllowCopilotFeedback: 'L_SendCopilotFeedback',
    policyAllowSurvey: 'L_SendSurvey',
    policyAllowScreenshot: 'L_Screenshot',
    policyAllowContact: 'L_EmailCollection',
    policyAllowContent: 'L_LogCollection',
    policyEmailCollectionDefault: 'emaildefault',
    policyScreenshotDefault: 'screenshotdefault',
    policyContentSamplesDefault: 'contentsamplesdefault',
    optionalConnectedExperiences: 'L_OptionalConnectedExperiences',
};
